import { createTheming } from "@callstack/react-theme-provider";

import { defaultTheme } from "./defaultTheme";

export const { ThemeProvider, useTheme, withTheme } =
  createTheming(defaultTheme);
